import React, { useMemo } from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap"

/**
 * Session Timeout Warning Modal
 * Shows warning when user session is about to expire due to inactivity
 * 
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether modal is visible
 * @param {number} props.remainingTime - Remaining time in milliseconds
 * @param {Function} props.onContinue - Called when user clicks "Continue Session"
 * @param {Function} props.onLogout - Called when user clicks "Logout Now"
 */
const SessionTimeoutModal = ({ isOpen, remainingTime, onContinue, onLogout }) => {
  // Format remaining time as MM:SS
  const formattedTime = useMemo(() => {
    const totalSeconds = Math.max(0, Math.floor(remainingTime / 1000))
    const minutes = Math.floor(totalSeconds / 60)
    const seconds = totalSeconds % 60
    return `${minutes}:${seconds.toString().padStart(2, "0")}`
  }, [remainingTime])

  return (
    <Modal
      isOpen={isOpen}
      centered={true}
      fade={true}
      backdrop="static"
      keyboard={false}
      className="session-timeout-modal"
    >
      <ModalHeader className="border-0 pb-0">
        <div className="d-flex align-items-center gap-2">
          <i className="mdi mdi-clock-alert-outline text-warning fs-4"></i>
          <span>เซสชันใกล้หมดอายุ</span>
        </div>
      </ModalHeader>
      <ModalBody className="text-center py-4">
        <div className="mb-3">
          <div 
            className="d-inline-flex align-items-center justify-content-center rounded-circle bg-warning bg-opacity-10 mb-3"
            style={{ width: "80px", height: "80px" }}
          >
            <span className="text-warning fw-bold fs-2">{formattedTime}</span>
          </div>
        </div>
        <p className="mb-0 text-muted">
          เซสชันของคุณจะหมดอายุเนื่องจากไม่มีกิจกรรม
          <br />
          คลิก &lsquo;ดำเนินการต่อ&rsquo; เพื่อใช้งานต่อ
        </p>
      </ModalBody>
      <ModalFooter className="border-0 pt-0">
        <div className="d-flex gap-3 w-100 justify-content-center">
          <Button
            color="light"
            outline
            className="px-4"
            onClick={onLogout}
          >
            ออกจากระบบ
          </Button>
          <Button
            color="primary"
            className="px-4"
            onClick={onContinue}
          >
            ดำเนินการต่อ
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  )
}

export default SessionTimeoutModal
